module.exports = __webpack_public_path__ + "20250721160708/img/teacher_manage.9cc0b054.png";